export function fmtDuration(ms: number): string {
	if (ms < 1000) return `${ms}ms`;
	if (ms < 60_000) return `${(ms / 1000).toFixed(1)}s`;
	return `${Math.floor(ms / 60_000)}m ${Math.round((ms % 60_000) / 1000)}s`;
}

export function fmtRelativeTime(ts: number, now: number = Date.now()): string {
	const diff = now - ts;
	if (diff < 0) return "just now";
	if (diff < 60_000) return "just now";
	if (diff < 60 * 60_000) return `${Math.round(diff / 60_000)}m ago`;
	if (diff < 24 * 60 * 60_000) return `${Math.round(diff / (60 * 60_000))}h ago`;
	return `${Math.round(diff / (24 * 60 * 60_000))}d ago`;
}

export function fmtInterval(ms: number): string {
	if (ms < 1000) return `${ms}ms`;
	if (ms < 60_000) return `${Math.round(ms / 1000)}s`;
	if (ms < 60 * 60_000) return `${Math.round(ms / 60_000)}m`;
	const hours = ms / (60 * 60_000);
	if (Math.abs(hours - Math.round(hours)) < 0.05) return `${Math.round(hours)}h`;
	return `${hours.toFixed(1)}h`;
}

/** "4d", "3mo" — coarse on purpose; exact timing is on the product page. */
export function fmtGone(since: number, now: number): string {
	const d = Math.max(0, now - since);
	const days = Math.floor(d / 86_400_000);
	if (days < 1) return "today";
	if (days < 30) return `${days}d`;
	const months = Math.floor(days / 30);
	if (months < 12) return `${months}mo`;
	return `${Math.floor(days / 365)}y`;
}
